import { render, staticRenderFns } from "./EnRuikaBandChart.vue?vue&type=template&id=789315b0&scoped=true"
import script from "./EnRuikaBandChart.vue?vue&type=script&lang=ts"
export * from "./EnRuikaBandChart.vue?vue&type=script&lang=ts"
import style0 from "./EnRuikaBandChart.vue?vue&type=style&index=0&id=789315b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789315b0",
  null
  
)

export default component.exports